<template>
    <div id="airwayHeatmapContainer" class="airway-mode-item"
        v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">
        <div class="airway-heatmap"></div>
        <div class="airway-ticks">
            <div class="airway-tick" v-for="tick in ticks">
                <sup class="airway-tick-line">|</sup>{{ tick }}
            </div>
            <div class="airway-mm">mm<sup>2</sup></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "AirwayHeatmap",
    props: ["mode"],
    data() {
        return {
            ticks:
                [
                    "50",
                    "183.3",
                    "316.7",
                    "450.0"
                ]
        };
    },
    components: {},
    mounted() {
        console.log("AirwayHeatmap mounted");
    },
    methods: {
        viewAirway: function () { }
    }
};


</script>

<style scoped>
#airwayHeatmapContainer {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 160px;
    height: 20px;
}

.airway-heatmap {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right,
            hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%),
            hsl(150, 100%, 50%), hsl(165, 100%, 50%), hsl(180, 100%, 50%),
            hsl(195, 100%, 50%), hsl(210, 100%, 50%), hsl(240, 100%, 50%));
}

.airway-ticks {
    display: flex;
    font-size: 12px;
    font-weight: 500;
    /* color: white; */
}

.airway-tick {
    margin-left: -1px;
    margin-right: 25.5px;
}

.airway-tick-line {
    font-weight: bold;
    font-size: 14px;
    margin-top: -5px;
}

.airway-mm {
    margin-left: -24.5px;
}
</style>